export default __webpack_public_path__ + "static/media/default_song_cover1.8df6a039.png";